import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { finalize } from "rxjs/operators";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";

@Component({
  selector: "app-upload-in-garantie",
  templateUrl: "./upload-in-garantie.component.html",
  styleUrls: ["./upload-in-garantie.component.scss"],
})
export class UploadInGarantieComponent implements OnInit {
  @Input() codeDocument;
  @Input() displayname;
  @Input() requestId;
  garantieid: number;
  form: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  constructor(
    private spinner: NgxSpinnerService,
    private _gestionFichierService: GestionFichierService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {
    this.createForm();
  }
  ngOnInit() {}

  createForm() {
    this.form = this.fb.group({
      codeDocument: [null, Validators.compose([Validators.required])],
      displayName: [null, Validators.compose([Validators.required])],
      fichier: [null, Validators.compose([Validators.required])],
      checkDoc: [null, Validators.compose([Validators.required])],
      motif: [null, Validators.compose([Validators.nullValidator])],
    });
  }

  uploadInDocumentGarantie(): void {
    const codedocument = this.form.value.codeDocument;
    const displayname = this.form.value.displayName;
    const fichier = this.form.value.fichier.files[0];
    const commentaire = this.form.value.motif;
    const checked = this.form.value.checkDoc;

    this.spinner.show();
    this._gestionFichierService
      .uploadInDocumentGarantie(
        fichier,
        codedocument,
        displayname,
        checked,
        commentaire,
        this.requestId,
        this.garantieid
      )
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (data) => {
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error.message;
        }
      );
  }
}
